'use strict';

module.exports = require('react/lib/ReactDOMServer');



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-dom/server.js
 ** module id = 317
 ** module chunks = 1
 **/